import { useCallback, useEffect, useRef, useState } from 'react';
import { supabase } from '../supabaseClient';

/**
 * G5E — lê v_contato_relationship_context (contatos com vínculos curados/representados).
 * Colunas: contato_id, first_name, last_name, email, curated_empresa_id,
 *          represented_empresas (jsonb[]), represented_imoveis (jsonb[]).
 * Retorna o contrato padrão da casa: { data, loading, error, refetch }.
 */
export function useContactRelationships() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const reqRef = useRef(0);

  const refetch = useCallback(async () => {
    const seq = ++reqRef.current;
    setLoading(true);
    setError(null);
    const { data: rows, error: err } = await supabase
      .from('v_contato_relationship_context')
      .select('*')
      .order('last_name', { ascending: true })
      .order('first_name', { ascending: true });
    if (seq !== reqRef.current) return; // resposta obsoleta — ignora
    if (err) {
      setError(err.message || String(err));
      setData([]);
    } else {
      setData(rows || []);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, loading, error, refetch };
}
